/*global Modernizr:true, window, jQuery */

/**
 * Sitewide JS
 *
 * @author Red Tiki <info@redtiki.co>
 */

(function ($) {
  //console.log('test');
  var $navItems = $('#site-header .navbar-nav > li');
  function clearTabs() {
    $('#site-header .navbar-nav > li , .subnav-content > .subnavtab.active').removeClass('active');
  }
  function strapHeight(height, el) {
    $('.subnav-content').stop(true).animate({height: height}, 300, function () {
      $(el).addClass('active');
    });
  }
  $(document).ready(function () {
    var defaultHeight = $('#default-panel').outerHeight();
    if (Modernizr.mq('only all and (min-width: 768px)')) {
      $navItems.on('mouseover tap', function (e) {
        if (e.type === 'tap') {
          e.preventDefault();
        }
        $navItems.removeClass('active');
        $(this).addClass('active');
        if ($(this).hasClass('dropdown')) {
          var subnav = '#' + $(this).attr('id') + '-panel';
          if ($('.subnav-content').find(subnav)[0]) {
            if (!$(subnav).hasClass('active')) {
              $('.subnav-content > .active').removeClass('active');
              var tabHeight = $(subnav).outerHeight() + $(subnav).find('ul li ul').outerHeight();
              strapHeight(tabHeight, subnav);
            }
          }
        } else {
          if (!$('#default-panel').hasClass('active')) {
            clearTabs();
            strapHeight(defaultHeight, '#default-panel');
          }
        }
      });
    }

    $('#site-header .navbar-nav').on('mouseleave', function () {
      $navItems.removeClass('active');
    });

    $('header#site-header').on('mouseleave', function () {
      if ($('#default-panel').hasClass('active')) {
        clearTabs();
      } else {
        clearTabs();
        strapHeight(defaultHeight, '#default-panel');
      }
    });

    /*
    // Did this with CSS instead...
    $('.subnav-content ul.row > li').on( 'mouseover', function (e) {
      if (!$(this).hasClass('active')) {
        $(this).parent().find('li.active').removeClass('active');
        $(this).addClass('active');
      }
    });
    */

    /**
     * Scroll smoothly to the part of the page where the hash is located.
     * Also change the browser location URL to include the hash.
     * If no hash is found, asume the link is going to a different page. Load this page.
     */
    $('a.smooth-scroll').on('click', function (e) {
      var anchor = e.target.hash;
      if (anchor) {
        $('html, body').stop().animate(
          {
            scrollTop: $(anchor).offset().top
          },
          1200,
          function () {
            window.location.hash = anchor;
          }
        );
        return false;
      }
    });

    /* Check Placeholders */
    if (!Modernizr.input.placeholder) {
      $('input[type="text"], input[type="email"], textarea').each(function (index, el) {
        var $this = $(el),
          v = $this.attr('placeholder');
        $this.val(v);
        $this.on('focus', function () {
          if ($this.val() === v) {
            $this.val('');
          }
        }).on('blur', function () {
          if ($this.val() === '') {
            $this.val(v);
          }
        });
      });
    }
    /* CAROUSEL SLIDER GALLER */
    var OWLCAROUSELOPTIONS = {
      NAVTEXT : [
        "<svg xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\" class=\"svg-icon-chevron-left\"><use xlink:href=\"/output/svgs.svg#icons_svg-icon-chevron-left\"></use></svg>",
        "<svg xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\" class=\"svg-icon-chevron-right\"><use xlink:href=\"/output/svgs.svg#icons_svg-icon-chevron-right\"></use></svg>"
      ],
      get LESSTHREE() {
        return {
          navText: this.NAVTEXT,
          responsive: {
            0: {
              nav: true,
              items: 1
            },
            768: {
              nav: false,
              items: 3
            }
          }
        };
      },
      set LESSTHREE(value) {
        this._value = value;
      },
      // if more than 3 items in carousel:
      get MORETHREE() {
        return {
          nav: true,
          navText: this.NAVTEXT,
          responsive: {
            0: {
              items: 1
            },
            768: {
              items: 3
            }
          }
        };
      },
      set MORETHREE(value) {
        this._value = value;
      },
      // the our-team slider gets 6 items per slide
      get OURTEAM() {
        return {
          nav: true,
          loop: true,
          navText: this.NAVTEXT,
          responsive: {
            0: {
              items: 2
            },
            768: {
              margin: 30,
              items: 3
            },
            992: {
              margin: 30,
              items: 6
            }
          }
        };
      },
      set OURTEAM(value) {
        this._value = value;
      }
    }

    $.each($('.multi-item-carousel'), function () {
      if ($(this).children().length <= 3) {
        $(this).owlCarousel(OWLCAROUSELOPTIONS.LESSTHREE);
      } else {
        if ($(this).hasClass('our-team')) {
          $(this).owlCarousel(OWLCAROUSELOPTIONS.OURTEAM);
        } else {
          $(this).owlCarousel(OWLCAROUSELOPTIONS.MORETHREE);
        }
      }
    });
  });

})(jQuery);